export enum Pages {
    AUDIO,
    DANCERS,
    STAGE,
    SET_PIECES,
    ACOUSTICS
};